import request from '@/api/base'

// 通用文件上传
const fileUpload = (params) => {
  return request.post('/area-admin/rest/fileupload', params, {
    'Content-Type': 'multipart/form-data'
  })
}
const uploader = (params) => {
  return request.post('/portal/images/upload', params)
}

// 获取下载模板
const downloadUserTemplate = (params) => {
  return request.post('/portal/file/downloadUserTemplate', params, {responseType: 'blob'})
}

// 登录获取验证码
const getSmsCode = params => {
  return request.post('/passport/sendSmsCode', params)
}

// 系统管理员退登
const userLogout = (params) => {
  return request.post('/portal/logout', params)
}

// 修改密码
const updateUmUserPassword = (params) => {
  return request.post('/passport/updatePassword', params)
}

// 获取房间树
const getAreaBuilding = (params) => {
  return request.post('/ipark-admin/building/getAreaBuilding', params)
}

// 获取上传文件全地址
const getTokenUrl = (params) => {
  return request.get('/portal/images/tokenUrl', {params})
}
// 检查手机号是否存在
const findUserIsExit = (params) => {
  return request.get('/portal/user/findUserIsExit', {params})
}
// 检查企业信用代码是否存在
const checkCreditCode = (params) => {
  return request.post('/portal/company/checkCreditCode', params)
}
// 获取房源
const getAllStructuredEstateInfo = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/room/getAllStructuredEstateInfo', params)
}
// 埋点接口
const eventtrackCommit = (params) => {
  return request.post('/portal/open/eventtrack/commitWeb', params)
}
// const eventtrackCommit = (params) => {
//   return request.post('/portal/open/eventtrack/commit', params)
// }
export default {
  fileUpload,
  downloadUserTemplate,
  getSmsCode,
  userLogout,
  updateUmUserPassword,
  getAreaBuilding,
  uploader,
  getTokenUrl,
  findUserIsExit,
  checkCreditCode,
  getAllStructuredEstateInfo,
  eventtrackCommit
}



// WEBPACK FOOTER //
// ./src/area-base/api/commonService.js